export default "__VITE_ASSET__BLc554My__"